/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientSymptomHistory } from 'app/shared/model/patient-symptom-history.model';
import { ISymptomAttribute } from 'app/shared/model/symptom-attribute.model';

export interface IPatientSymptomAttribute {
  id?: string;
  resultValue?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  symptomOrder?: number | null;
  symptomHistory?: IPatientSymptomHistory | null;
  attribute?: ISymptomAttribute | null;
}

export const defaultValue: Readonly<IPatientSymptomAttribute> = {
  active: false,
};
